// src/pages/Users/News/components/NewsImageModal.jsx

import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { FaTimes } from "react-icons/fa";

import { FALLBACK_NEWS_IMG } from "../utils/newsUtils";

function onImgError(event) {
  if (event?.currentTarget) {
    event.currentTarget.src = FALLBACK_NEWS_IMG;
  }
}

export default function NewsImageModal({ isOpen, imageUrl, title, onClose }) {
  useEffect(() => {
    if (!isOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-[9999] bg-slate-950/90 p-3 backdrop-blur-sm sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-label="Agrandir l’image"
      onClick={onClose}
    >
      <div
        className="flex h-full flex-col"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="flex items-center justify-between gap-3 text-white">
          <p className="line-clamp-1 text-sm font-bold">{title || "Image"}</p>

          <button
            type="button"
            onClick={onClose}
            className="flex h-12 w-12 items-center justify-center rounded-full bg-white/10 text-white backdrop-blur transition hover:bg-white/20 active:scale-95"
            aria-label="Fermer"
          >
            <FaTimes />
          </button>
        </header>

        <div className="flex flex-1 items-center justify-center py-4">
          <img
            src={imageUrl || FALLBACK_NEWS_IMG}
            alt={title || "Image actualité"}
            className="max-h-[82dvh] w-full max-w-6xl rounded-[1.5rem] object-contain shadow-2xl"
            onError={onImgError}
          />
        </div>
      </div>
    </div>,
    document.body
  );
}